"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var bbox_exports = {};
__export(bbox_exports, {
  bboxCenter: () => bboxCenter,
  bboxNe: () => bboxNe,
  bboxSw: () => bboxSw,
  isBBox: () => isBBox,
  isBBox4: () => isBBox4,
  isBBox6: () => isBBox6,
  normalizeBBox: () => normalizeBBox,
  toBBox4: () => toBBox4,
  toBBox6: () => toBBox6
});
module.exports = __toCommonJS(bbox_exports);
var import_guard = require("@cartographerio/guard");
function isBBox(value) {
  return (0, import_guard.isArray)(value) && (value.length === 4 || value.length === 6) && value.every(import_guard.isNumber);
}
function isBBox4(value) {
  return (0, import_guard.isArray)(value) && value.length === 4 && value.every(import_guard.isNumber);
}
function isBBox6(value) {
  return (0, import_guard.isArray)(value) && value.length === 6 && value.every(import_guard.isNumber);
}
function toBBox4(bbox) {
  return bbox.length === 4 ? bbox : [bbox[0], bbox[1], bbox[3], bbox[4]];
}
function toBBox6(bbox) {
  return bbox.length === 6 ? bbox : [bbox[0], bbox[1], 0, bbox[2], bbox[3], 0];
}
function bboxCenter(bbox) {
  return isBBox4(bbox) ? [(bbox[0] + bbox[2]) / 2, (bbox[1] + bbox[3]) / 2] : [(bbox[0] + bbox[3]) / 2, (bbox[1] + bbox[4]) / 2, (bbox[2] + bbox[5]) / 2];
}
function bboxSw(bbox) {
  return isBBox4(bbox) ? [bbox[0], bbox[1]] : [bbox[0], bbox[1], bbox[2]];
}
function bboxNe(bbox) {
  return isBBox4(bbox) ? [bbox[2], bbox[3]] : [bbox[3], bbox[4], bbox[5]];
}
function normalizeBBox(bbox) {
  if (isBBox4(bbox)) {
    return [
      Math.min(bbox[0], bbox[2]),
      Math.min(bbox[1], bbox[3]),
      Math.max(bbox[0], bbox[2]),
      Math.max(bbox[1], bbox[3])
    ];
  } else {
    return [
      Math.min(bbox[0], bbox[3]),
      Math.min(bbox[1], bbox[4]),
      Math.min(bbox[2], bbox[5]),
      Math.max(bbox[0], bbox[3]),
      Math.max(bbox[1], bbox[4]),
      Math.max(bbox[2], bbox[5])
    ];
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  bboxCenter,
  bboxNe,
  bboxSw,
  isBBox,
  isBBox4,
  isBBox6,
  normalizeBBox,
  toBBox4,
  toBBox6
});
//# sourceMappingURL=bbox.js.map
